import restaurantStamp from "./images/restaurant-stamp.png"
import educationStamp from "./images/education-stamp.png"
import cultureStamp from "./images/culture-stamp.png"
import parksStamp from "./images/parks-stamp.png"
import shopsStamp from "./images/shops-stamp.png"
import transportStamp from "./images/transport-stamp.png"
import marketsStamp from "./images/markets-stamp.png"

import inactiveRestaurantStamp from "./images/restaurant-stamp-inactive.png"
import inactiveEducationStamp from "./images/education-stamp-inactive.png"
import inactiveCultureStamp from "./images/culture-stamp-inactive.png"
import inactiveParksStamp from "./images/parks-stamp-inactive.png"
import inactiveShopsStamp from "./images/shops-stamp-inactive.png"
import inactiveTransportStamp from "./images/transport-stamp-inactive.png"
import inactiveMarketsStamp from "./images/markets-stamp-inactive.png"

import restaurantPin from "./images/drink_pinpoint.svg"
import educationPin from "./images/education_pinpoint.svg"
import culturePin from "./images/culture_pinpoint.svg"
import parksPin from "./images/park_pinpoint.svg"
import shopsPin from "./images/shop_pinpoint.svg"
import transportPin from "./images/travel_pinpoint.svg"
import marketsPin from "./images/market_pinpoint.svg"

import restaurantInfo from "./images/restaurant-large.svg"
import educationInfo from "./images/education-large.svg"
import cultureInfo from "./images/culture-large.svg"
import parksInfo from "./images/parks-large.svg"
import shopsInfo from "./images/shops-large.svg"
import transportInfo from "./images/transport-large.svg"
import marketsInfo from "./images/markets-large.svg"

import cultureTitle from "./images/culture_title.svg"
import parksTitle from "./images/parks_title.svg"
import marketsTitle from "./images/markets_title.svg"
import educationTitle from "./images/education_title.svg"
import drinkTitle from "./images/drink_title.svg"
import shopTitle from "./images/markets_title.svg"
import transportTitle from "./images/travel_title.svg"

const categories = [
  {
    name: "Cultural",
    color: "#A0B3AA",
    icon: inactiveCultureStamp,
    activeIcon: cultureStamp,
    title: cultureTitle,
    subTitle: `Many top cultural and educational institutions are just minutes from Postmark.`,
    description: `Be inspired by a ground-breaking exhibition at the Barbican Centre followed by a lunchtime lecture at SOAS or Central St Martins. Head over to Bloomsbury to brush up on your human history at the British Museum, and finish with a spellbinding performance at Covent Garden’s stunning Royal Opera House.`,
    smallIcon: culturePin,
    largeIcon: cultureInfo,
    locations: [
      {
        name: "Barbican Centre",
        coordinates: [-0.0937864, 51.5202077],
        distances: [24, 9, 21]
      },
      {
        name: "The Postal Museum",
        coordinates: [-0.113926, 51.524751],
        distances: [3, 1, "-"]
      },
      {
        name: "The British Library",
        coordinates: [-0.1276759, 51.5299717],
        distances: [21, 8, 17]
      },
      {
        name: "Sadler's Wells Theatre",
        coordinates: [-0.1060954, 51.5296825],
        distances: [12, 5, 9]
      },
      {
        name: "Royal Courts of Justice",
        coordinates: [-0.1132125, 51.5136609],
        distances: [17, 8, 16]
      },
      {
        name: "Deloitte",
        coordinates: [-0.1076917, 51.5157123],
        distances: [15, 7, 11]
      },
      {
        name: "Goldman Sachs International",
        coordinates: [-0.1063036, 51.5164509],
        distances: [13, 7, 12]
      },
      {
        name: "Gagosian",
        coordinates: [-0.118019, 51.530069],
        distances: [14, 6, 12]
      },
      {
        name: "London Stock Exchange",
        coordinates: [-0.099034, 51.5150534],
        distances: [20, 10, 13]
      },
      {
        name: "The British Museum",
        coordinates: [-0.1269566, 51.5194133],
        distances: [15, 7, 14]
      },
      {
        name: "Somerset House",
        coordinates: [-0.117148, 51.511059],
        distances: [23, 9, 17]
      },
      {
        name: "Antoni & Alison",
        coordinates: [-0.1111729, 51.5243228],
        distances: [3, 1, "-"]
      },
      {
        name: "Royal Opera House",
        coordinates: [-0.1221976, 51.5129211],
        distances: [21, 9, 18]
      },
      {
        name: "Charles Dickens Museum",
        coordinates: [-0.1162944, 51.5235861],
        distances: [4, 3, "-"]
      },
      {
        name: "Hatton Garden",
        coordinates: [-0.1081618, 51.5194751],
        distances: [7, 3, "-"]
      }
    ]
  },
  {
    name: "Parks and Green Spaces",
    color: "#49695A",
    icon: inactiveParksStamp,
    activeIcon: parksStamp,
    title: parksTitle,
    subTitle: `With many of  the nearby green spaces, you will never be short of a space to relax or meet with friends.`,
    description: `Be inspired by a ground-breaking exhibition at the Barbican Centre followed by a lunchtime lecture at SOAS or Central St Martins. Head over to Bloomsbury to brush up on your human history at the British Museum, and finish with a spellbinding performance at Covent Garden’s stunning Royal Opera House.`,
    smallIcon: parksPin,
    largeIcon: parksInfo,
    locations: [
      {
        name: "Lincoln's Inn Fields",
        coordinates: [-0.1178205, 51.5156073],
        distances: [13, 6, 14]
      },
      {
        name: "Granary Square",
        coordinates: [-0.1252334, 51.535202],
        distances: [25, 10, 17]
      },
      {
        name: "Coram's Fields",
        coordinates: [-0.1196788, 51.5246665],
        distances: [8, 4, "-"]
      },
      {
        name: "Russell Square",
        coordinates: [-0.12589, 51.52175],
        distances: [15, 6, 15]
      },
      {
        name: "Regent's Canal",
        coordinates: [-0.1025375, 51.5330928],
        distances: [19, 8, 15]
      },
      {
        name: "Shoreditch Park",
        coordinates: [-0.0860529, 51.5345749],
        distances: [36, 12, 31]
      },
      {
        name: "Brunswick Square",
        coordinates: [-0.1226079, 51.5242289],
        distances: [11, 4, "-"]
      },
      {
        name: "Regent's Park",
        coordinates: [-0.1608797, 51.5247543],
        distances: [52, 22, 26]
      }
    ]
  },
  {
    name: "Markets",
    color: "#AC213E",
    icon: inactiveMarketsStamp,
    activeIcon: marketsStamp,
    title: marketsTitle,
    subTitle: `From notable flagships to highend hidden boutiques, there’s nowhere else in the world like London for shopping.`,
    description: `For unusual gifts and accessories, browse the independent stores on Exmouth Market. Continue on to Coal Drops Yard for an eclectic mix of new and established brands and an al fresco lunch, or head south to Covent Garden’s charming pedestrianised streets for the latest designer boutiques and high-street names`,
    smallIcon: marketsPin,
    largeIcon: marketsInfo,
    locations: [
      {
        name: "Exmouth Market",
        coordinates: [-0.1093193, 51.5258212],
        distances: [5, 3, "-"]
      },
      {
        name: "Spitalfields Market",
        coordinates: [-0.0768491, 51.5197684],
        distances: [39, 14, 22]
      }
    ]
  },
  {
    name: "Education",
    color: "#94979C",
    icon: inactiveEducationStamp,
    activeIcon: educationStamp,
    title: educationTitle,
    subTitle: `Voted Number 1 International Student City in the World.`,
    description: `London boats a world-leading education, with many top educational institutions being just minutes from Postmark.`,
    smallIcon: educationPin,
    largeIcon: educationInfo,
    locations: [
      {
        name: "Central Saint Martins",
        coordinates: [-0.1245762, 51.5363807],
        distances: [25, 10, 19]
      },
      {
        name: "Hult International Business School London Graduate Campus",
        coordinates: [-0.1151065, 51.5214476],
        distances: [48, 18, 26]
      },
      {
        name: "King's College London",
        coordinates: [-0.115997, 51.5114864],
        distances: [21, 9, 18]
      },
      {
        name: "SOAS University of London",
        coordinates: [-0.129259, 51.52235],
        distances: [18, 7, 21]
      },
      {
        name: "Birkbeck, University of London",
        coordinates: [-0.1303146, 51.5218563],
        distances: [19, 6, 21]
      },
      {
        name: "Architectural Association",
        coordinates: [-0.1309354, 51.5183947],
        distances: [22, 9, 15]
      },
      {
        name: "Cass Business School",
        coordinates: [-0.090184, 51.5218644],
        distances: [26, 8, 21]
      },
      {
        name: "London School of Economics and Political Science",
        coordinates: [-0.1164513, 51.5144388],
        distances: [19, 5, 17]
      },
      {
        name: "University of London",
        coordinates: [-0.1308206, 51.5229378],
        distances: [17, 6, "-"]
      },
      {
        name: "University of the Arts London",
        coordinates: [-0.1165507, 51.5178589],
        distances: [11, 5, 12]
      },
      {
        name: "City of London School for Girls",
        coordinates: [-0.0944913, 51.519202],
        distances: [14, 6, "-"]
      },
      {
        name: "City, University of London",
        coordinates: [-0.1024624, 51.5279719],
        distances: [10, 15, 10]
      },
      {
        name: "University College London",
        coordinates: [-0.1340401, 51.5245592],
        distances: [19, 7, 18]
      }
    ]
  },
  {
    name: "Restaurants, Bars, Coffee Shops",
    color: "#7997A9",
    icon: inactiveRestaurantStamp,
    activeIcon: restaurantStamp,
    title: drinkTitle,
    subTitle: `Feast your senses on the neighbourhood’s fine array of international cuisine.`,
    description: `Start your day with a flat white at Mousetail Coffee or a weekend brunch at Caravan. For after-work dinner with friends, try the stand-out tapas at Moro or classic British fare at St. John. To round off your night, head to The Zetter Townhouse hotel for cocktails, just round the corner from home.`,
    smallIcon: restaurantPin,
    largeIcon: restaurantInfo,
    locations: [
      {
        name: "Chinatown",
        coordinates: [-0.1311148, 51.5117912],
        distances: [27, 13, 17]
      },
      {
        name: "Soho",
        coordinates: [-0.1365486, 51.5136143],
        distances: [32, 12, 19]
      },
      {
        name: "Marylebone",
        coordinates: [-0.1498955, 51.5188746],
        distances: [46, 19, 22]
      },
      {
        name: "Covent Garden",
        coordinates: [-0.1240436, 51.5116571],
        distances: [24, 11, 18]
      },
      {
        name: "Broadgate",
        coordinates: [-0.0834664, 51.5191054],
        distances: [32, 11, 20]
      },
      {
        name: "Coal Drops Yard",
        coordinates: [-0.1264545, 51.5358763],
        distances: [28, 10, 20]
      },
      {
        name: "The Angel",
        coordinates: [-0.1042905, 51.5346761],
        distances: [0, 0, "-"]
      },
      {
        name: "Gallipoli Again",
        coordinates: [-0.102623, 51.5385662],
        distances: [0, 0, "-"]
      },
      {
        name: "Old Street",
        coordinates: [-0.0886259, 51.5255233],
        distances: [23, 8, 17]
      },
      {
        name: "Shoreditch",
        coordinates: [-0.0777472, 51.5229106],
        distances: [35, 12, 25]
      },
      {
        name: "The Ned",
        coordinates: [-0.0899158, 51.5138264],
        distances: [29, 10, 13]
      },
      {
        name: "Polpo Soho",
        coordinates: [-0.137602, 51.512456],
        distances: [0, 0, "-"]
      },
      {
        name: "Frederick's",
        coordinates: [-0.104305, 51.5343622],
        distances: [20, 9, 15]
      },
      {
        name: "Ottolenghi Islington",
        coordinates: [-0.1023371, 51.539742],
        distances: [28, 9, 17]
      },
      {
        name: "The Island Queen",
        coordinates: [-0.0984406, 51.5331756],
        distances: [23, 9, 21]
      },
      {
        name: "Narrowboat",
        coordinates: [-0.0969101, 51.5330598],
        distances: [25, 10, 22]
      },
      {
        name: "Shoreditch House",
        coordinates: [-0.0759327, 51.5237811],
        distances: [37, 13, 26]
      },
      {
        name: "Fitzrovia",
        coordinates: [-0.1365872, 51.5214993],
        distances: [28, 8, 25]
      },
      {
        name: "Club Gascon - French Michelin Starred Restaurant",
        coordinates: [-0.1002364, 51.5186292],
        distances: [15, 7, 12]
      },
      {
        name: "Gallipoli Cafe & Bistro",
        coordinates: [-0.1029764, 51.5377006],
        distances: [0, 0, "-"]
      },
      {
        name: "Palatino",
        coordinates: [-0.0967936, 51.5266332],
        distances: [18, 7, 16]
      },
      {
        name: "The Green",
        coordinates: [-0.1064032, 51.5227488],
        distances: [7, 3, "-"]
      },
      {
        name: "LINO",
        coordinates: [-0.0989496, 51.5179099],
        distances: [17, 7, 16]
      },
      {
        name: "SUSHISAMBA London",
        coordinates: [-0.0809644, 51.5162822],
        distances: [22, 9, 16]
      },
      {
        name: "Yauatcha",
        coordinates: [-0.1352058, 51.5135819],
        distances: [31, 12, 21]
      },
      {
        name: "Smiths of Smithfield",
        coordinates: [-0.1027614, 51.5195203],
        distances: [14, 5, 11]
      },
      {
        name: "Luca",
        coordinates: [-0.1016722, 51.5220361],
        distances: [12, 5, 12]
      },
      {
        name: "The Clerkenwell Kitchen",
        coordinates: [-0.1067861, 51.5241667],
        distances: [9, 4, "-"]
      },
      {
        name: "St. JOHN Restaurant",
        coordinates: [-0.1014304, 51.5204534],
        distances: [13, 5, 13]
      },
      {
        name: "Bourne & Hollingsworth Buildings",
        coordinates: [-0.1073241, 51.5255525],
        distances: [8, 4, "-"]
      },
      {
        name: "The Apple Tree",
        coordinates: [-0.1121355, 51.5235292],
        distances: [34, 15, 21]
      },
      {
        name: "The Coach",
        coordinates: [-0.1091667, 51.5230556],
        distances: [4, 1, "-"]
      },
      {
        name: "The Quality Chop House",
        coordinates: [-0.1098886, 51.5246849],
        distances: [5, 2, "-"]
      },
      {
        name: "Caravan Exmouth Market | Outdoor Dining, Takeaway & Coffee",
        coordinates: [-0.1100657, 51.5255125],
        distances: [5, 3, "-"]
      },
      {
        name: "Eataly London",
        coordinates: [-0.0801718, 51.5187586],
        distances: [37, 14, 19]
      },
      {
        name: "Ottolenghi Islington",
        coordinates: [-0.1023371, 51.539742],
        distances: [28, 9, 17]
      },
      {
        name: "Megan's at the Sorting Office Restaurant (Islington Square)",
        coordinates: [-0.1039061, 51.5390277],
        distances: [29, 10, 18]
      },
      {
        name: "Mouse Tail Coffee",
        coordinates: [-0.1123323, 51.523646],
        distances: [1, 1, "-"]
      },
      {
        name: "Moro",
        coordinates: [-0.1090022, 51.5258822],
        distances: [6, 4, "-"]
      },
      {
        name: "Rosewood London",
        coordinates: [-0.1179599, 51.517669],
        distances: [12, 5, 10]
      },
      {
        name: "The Waldorf Hilton, London",
        coordinates: [-0.1189789, 51.5125386],
        distances: [21, 8, 16]
      },
      {
        name: "Angler",
        coordinates: [-0.0864165, 51.5190865],
        distances: [29, 10, 20]
      },
      {
        name: "100 Liverpool Street - Broadgate",
        coordinates: [-0.0830936, 51.5183046],
        distances: [31, 11, 18]
      },
      {
        name: "Broadgate",
        coordinates: [-0.0834664, 51.5191054],
        distances: [32, 11, 20]
      },
      {
        name: "Russell Square",
        coordinates: [-0.1258364, 51.5228982],
        distances: [16, 8, 15]
      }
    ]
  },

  {
    name: "Shops",
    color: "#AC213E",
    icon: inactiveShopsStamp,
    activeIcon: shopsStamp,
    title: shopTitle,
    subTitle: `From notable flagships to highend hidden boutiques, there’s nowhere else in the world like London for shopping.`,
    description: `For unusual gifts and accessories, browse the independent stores on Exmouth Market. Continue on to Coal Drops Yard for an eclectic mix of new and established brands and an al fresco lunch, or head south to Covent Garden’s charming pedestrianised streets for the latest designer boutiques and high-street names.`,
    smallIcon: shopsPin,
    largeIcon: shopsInfo,
    locations: [
      {
        name: "Marylebone",
        coordinates: [-0.1498955, 51.5188746],
        distances: [46, 17, 22]
      },
      {
        name: "Bond Street",
        coordinates: [-0.1491578, 51.5142641],
        distances: [37, 14, 16]
      },
      {
        name: "Tesco Express",
        coordinates: [-0.1060912, 51.520277],
        distances: [11, 5, 12]
      },
      {
        name: "Spitalfields Market",
        coordinates: [-0.0768491, 51.5197684],
        distances: [39, 14, 22]
      },
      {
        name: "Selfridges",
        coordinates: [-0.152767, 51.5144233],
        distances: [44, 15, 20]
      },
      {
        name: "Waitrose & Partners Clerkenwell",
        coordinates: [-0.1027702, 51.5241197],
        distances: [14, 7, "-"]
      },
      {
        name: "Coal Drops Yard",
        coordinates: [-0.1264545, 51.5358763],
        distances: [28, 10, 20]
      },
      {
        name: "Upper Street",
        coordinates: [-0.1034441, 51.5366024],
        distances: [28, 9, 20]
      },
      {
        name: "Islington High Street",
        coordinates: [-0.1059312, 51.5331619],
        distances: [18, 7, 13]
      },
      {
        name: "Bond Street",
        coordinates: [-0.1491578, 51.5142641],
        distances: [37, 14, 16]
      },
      {
        name: "Oxford Circus",
        coordinates: [-0.1419965, 51.5152858],
        distances: [32, 14, 13]
      },
      {
        name: "Spitalfields",
        coordinates: [-0.0748478, 51.5189263],
        distances: [39, 14, 20]
      },
      {
        name: "Oxford Street",
        coordinates: [-0.1420395, 51.5152543],
        distances: [0, 0, "-"]
      },
      {
        name: "Virgin Active",
        coordinates: [-0.1051354, 51.5313435],
        distances: [16, 7, 14]
      }
    ]
  },
  {
    name: "Transport",
    color: "#205373",
    icon: inactiveTransportStamp,
    activeIcon: transportStamp,
    title: transportTitle,
    subTitle: `Postmark couldn’t be better connected, however you like to get around.`,
    description: `The whole of central London is easily accessible on foot, by bike or a short taxi ride, or a tube journey from one of the four underground stations within a 15-minute walk. Plus, the arrival of London’s new Elizabeth line (formerly Crossrail) at Farringdon will make it even easier to get across town.`,
    smallIcon: transportPin,
    largeIcon: transportInfo,
    locations: [
      {
        name: "Farringdon",
        line: ["circle", "hammersmith", "metropolitan", "thameslink"],
        coordinates: [-0.1042414, 51.5215324],
        distances: [5, 5, 5]
      },
      {
        name: "Russell Square",
        line: ["piccadilly"],
        coordinates: [-0.1243155, 51.5230848],
        distances: [15, 5, 15]
      },
      {
        name: "Chancery Lane",
        line: ["circle"],
        coordinates: [-0.1114984, 51.5182067],
        distances: [9, 4, 6]
      },
      {
        name: "Holborn",
        line: ["circle", "piccadilly"],
        coordinates: [-0.1199355, 51.5175079],
        distances: [14, 6, 10]
      },
      {
        name: "Angel",
        line: ["northern"],
        coordinates: [-0.1061165, 51.5324196],
        distances: [16, 6, 11]
      },
      {
        // name: "St Pancras Int",
        line: ["vic", "piccadilly", "hammersmith", "metropolitan", "northern", "circle"],

        coordinates: [-0.126133, 51.531427],
        distances: [20, 7, 14]
      },
      {
        name: "King's Cross",
        line: ["cn", "gc", "ht", "lner", "cs", "thameslink"],
        coordinates: [-0.1234736, 51.5318504],
        distances: [17, 7, 12]
      }
    ]
  }
]

export default categories
